import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Help } from '@shared/constants/help';
import { userSelectors } from '@store/selectors/user.selectors';
import { StoreState } from '@store/store.state';
import { Store } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { AcRoutingService } from '@core/services/routing/ac-routing.service';
import { PortugalHelp } from '@shared/constants/portugal-help';

@Component({
  selector: 'ac-help',
  standalone: true,
  imports: [TranslateModule, RouterLink],
  templateUrl: './help.component.html',
  styleUrl: './help.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HelpComponent {
  protected readonly _emailSig = this._store.selectSignal(userSelectors.helpEmail);
  protected readonly _countrySig = this._store.selectSignal(userSelectors.country);
  protected readonly _spanishPhoneNumber: string = Help.PHONE;
  protected readonly _portugueseComercialPhoneNumber: string = PortugalHelp.PHONE_COMERCIAL;
  protected readonly _portugueseMeterReadingPhoneNumber: string = PortugalHelp.PHONE_METER_READING;
  protected readonly _portugueseOutagesPhoneNumber: string = PortugalHelp.PHONE;

  constructor(
    private readonly _store: Store<StoreState>,
    private readonly _routing: AcRoutingService
  ) {}

  protected _onContactUs() {
    window.open(`mailto:${this._emailSig()}`, '_blank', 'noopener');
  }
  protected _spanishCall() {
    window.open(`tel:${this._spanishPhoneNumber}`);
  }
  protected _portugueseComercialCall() {
    window.open(`tel:${this._portugueseComercialPhoneNumber}`);
  }
  protected _portugueseMeterReadingCall() {
    window.open(`tel:${this._portugueseMeterReadingPhoneNumber}`);
  }
  protected _portugueseOutagesCall() {
    window.open(`tel:${this._portugueseOutagesPhoneNumber}`);
  }
  protected _goToFAQ() {
    this._routing.goToFaq();
  }
}
